'use strict';

var customSwal = require('./customSwal');

/**
 * Reads promotion toast copy from page-level data attributes.
 *
 * @returns {{ successMessage: string, errorMessage: string }}
 */
function getConfig() {
	var $root = $('[data-promotion-toast]').first();

	return {
		successMessage: $root.attr('data-promotion-success-message') || '',
		errorMessage: $root.attr('data-promotion-error-message') || '',
	};
}

/**
 * Builds the promotion toast markup.
 *
 * @param {{ message?: string, error?: boolean }} payload
 * @returns {string}
 */
function buildHtml(payload) {
	var isError = !!payload.error;
	var message = payload.message || '';
	var iconClass = isError ? 'icon-exclamation-triangle' : 'icon-check';
	var statusModifier = isError ? ' sa-promotion-toast--error' : '';

	return (
		'<div class="sa-promotion-toast' +
		statusModifier +
		'" role="status" aria-live="polite">' +
		'<div class="sa-promotion-toast__status">' +
		'<span class="sa-promotion-toast__icon" aria-hidden="true">' +
		'<i class="' +
		iconClass +
		'"></i>' +
		'</span>' +
		'<p class="sa-promotion-toast__message">' +
		message +
		'</p>' +
		'</div>' +
		'</div>'
	);
}

/**
 * Opens the promotion toast; replaces any visible SweetAlert2 instance first.
 *
 * @param {{ message?: string, error?: boolean }} payload
 * @returns {Promise}
 */
function show(payload) {
	if (customSwal.Swal.isVisible()) {
		customSwal.Swal.close();
	}

	var toastConfig = getConfig();
	var isError = !!payload.error;
	var resolvedPayload = Object.assign({}, payload, {
		message: payload.message || (isError ? toastConfig.errorMessage : toastConfig.successMessage),
	});

	return customSwal.openToast({
		html: buildHtml(resolvedPayload),
		customClass: {
			container: 'sa-toast-container sa-toast-container--promotion',
			popup: 'sa-toast-popup',
			htmlContainer: 'sa-toast-html',
		},
	});
}

module.exports = {
	show: show,
};
